import classNames from 'classnames';
import PropTypes from 'prop-types';
import { memo } from 'react';

import {
  Dotdotdot,
} from '../../assets/js/svg/gui';
import {
  useTownAssets,
  useSingleCase,
} from '../../stores';
import {
  stringLowerCaseFirstLetter,
} from '../../utils';
import { Row } from '../display';

const CaseStatus = memo((props) => {
  const {
    setExpandControls,
  } = props;
  const { thisCase } = useSingleCase();
  const { assets } = useTownAssets();
  const {
    translate,
  } = assets;
  const {
    ready,
    csUid,
    status,
    csBtwnUsrs,
  } = thisCase;

  const statusClassName = classNames({
    'text-pxCaseOrangeLeft': status !== 'active',
  });

  if (!ready) {
    return (
      <Row className="bg-pxDarkBg1 text-pxAccentBlue between text-center justify-between">
        <div className="w-7.5" />
        <h3 className="my-1 mx-0">Loading...</h3>
        <div className="w-7.5" />
      </Row>
    );
  }

  const handleClick = () => {
    setExpandControls((prev) => (!prev));
  };

  return (
    <Row className="bg-pxDarkBg1 text-pxAccentBlue between text-center justify-between">
      <div className="w-7.5" />

      <h3 className="my-1 mx-0">
        {`${translate('case')} #${csUid} - `}
        <span className={statusClassName}>{translate(status, 'status')}</span>
        {(csBtwnUsrs)
          ? (
              <span className="text-pxAccentBlue">
                {` (${
                  stringLowerCaseFirstLetter(translate('betweenUsers'))})`}
              </span>
            )
          : null}
      </h3>

      <button
        type="button"
        className="w-7.5 h-full p-2 flex justify-center items-center"
        onClick={handleClick}
      >
        <Dotdotdot className="h-full fill-pxAccentBlue" />
      </button>
    </Row>
  );
});
CaseStatus.displayName = 'CaseStatus';

CaseStatus.propTypes = {
  setExpandControls: PropTypes.func.isRequired,
};

export default CaseStatus;
